import $x from '@/utils/$x';

// 添加内容
export async function addLittaContentPool(params) {
  return $x.post('/content/addLittaContentPool', params);
}

// 更新内容
export async function updateContentPool(params) {
  return $x.post('/content/updateContentPool', params);
}

// 上下线内容
export async function enableOrDisableContent(params) {
  return $x.post('/content/enableOrDisableContent', params);
}

// 分页查询内容列表
export async function getContentList(params) {
  return $x.post('/content/getLittaContentPage', params);
}

// 查询内容详情
export async function getLittaContentById(params) {
  return $x.post('/content/getLittaContentById', params);
}

//  根据id删除内容
export async function deleteContent(params) {
  return $x.post('/content/deleteContent', params);
}


/**
 *  品类
 */

//  查询品类树
export async function getCategoryTree(params) {
  return $x.post('/category/getLittaCategoryTree', params);
}

//  根据id查品类详情
export async function getLittaCategoryById(params) {
  return $x.post('/category/getLittaCategoryById', params);
}

// 根据一级分类的id获取绑定渠道
export async function getChannelByCategoryId(params) {
  return $x.post('/contentChannel/getChannelByCategoryId', params);
}

// 替换视频
export async function updatePlaybackUrl(params) {
  return $x.post('/content/updateMediaContent', params);
}

// 编辑分类介绍
export async function editLittaCategoryIntro(params) {
  return $x.post('/category/editLittaCategoryIntro', params);
}
